import gql from 'graphql-tag';


export const REAL_TIME_SUBSCRIPTION = gql`
subscription realTimeSubscription {
    realTimeSubscription {
        payload {
          fecha
          valor
          periodo
          topic
        }
    }
  }`


export const REAL_TIME_REQUEST = gql`
mutation realTimeRequest($topic: String, $payload: String) {
    realTimeRequest(topic: $topic, payload: $payload)
  }`